import React from 'react'
import { TPost } from '../../../../../types/Post';
import s from './TopAvatarTime.module.scss'
import moment from 'moment'
import { ReactComponent as Warning } from "../../../../assets/Warning.svg";
import classNames from 'classnames'
import { canProceedToModifyPost } from '../../../../helper/modify-post-starting-check';

function TopAvatarTime({ post, socialRepost }: { post: TPost, socialRepost?: boolean }): React.ReactElement {
    const ScheduledPostHeader = () => {
        return (
            <span className={classNames(s.scheduledPost)}>
                &nbsp;Scheuled for&nbsp;
                {(moment(post.creationTs).format("MMM D"))}
            </span>)
    }
    return (
        <div className={s.postTop} style={{ alignItems: 'center', }}>
            <div style={{ display: 'flex' }}>
                <img
                    src={post.user.avatar}
                    className={s.userAvatar}
                    alt={`${post.text && post.text.length ? post.text : 'user-image'}`}
                />
                <div className={s.userName}>
                    <div className='user-name'>{post.user.screenName}</div>
                    <div className='creation-date'>
                        {
                            Date.now() < post.creationTs ?
                                ScheduledPostHeader()
                                : (moment(post.creationTs).fromNow())
                        }
                    </div>
                </div>
            </div>
            {canProceedToModifyPost(post) &&
                <div className='action-warning'>
                    <Warning />
                    <span>Action needed</span>
                </div>
            }
        </div>
    )
}

export default TopAvatarTime 
